<div class="m-auto d-flex justify-content-center align-items-center" style=" width: 100vw; height: 100vh;">
    <div class="mx-auto my-auto">
        <div class="container">
            <div class="dot bg-white"></div>
            <div class="dot bg-white"></div>
            <div class="dot bg-white"></div>
            <div class="dot bg-white"></div>
            <div class="dot bg-white"></div>
        </div>
        <svg width="0" height="0" class="svg">
        <defs>
            <filter id="uib-jelly-ooze">
            <feGaussianBlur
                in="SourceGraphic"
                stdDeviation="3"
                result="blur"
            />
            <feColorMatrix
                in="blur"
                mode="matrix"
                values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                result="ooze"
            />
            <feBlend in="SourceGraphic" in2="ooze" />
            </filter>
        </defs>
        </svg>
    </div>

</div>

  

  
  
<!--div class="d-flex justify-content-center align-items-center" style="height: 100vh; min-width: 100vw;">
    <div class="lds-ellipsis d-flex flex-row justify-content-center m-auto align-items-center" style="margin: auto;">
        <div class="bg-light" style="background-color: white;"></div>
        <div class="bg-light" style="background-color: white;"></div>
        <div class="bg-light" style="background-color: white;"></div>
        <div class="bg-light" style="background-color: white;"></div>
    </div>
</div-->
